// extracted by mini-css-extract-plugin
module.exports = {"root":"SocialLinks_root__fcnMP","icon":"SocialLinks_icon__XzXGt"};